import styled from 'styled-components'

export const InvoiceListWrap = styled.div`
  display: block;
  width: 100%;
  overflow: auto;
`
